module.exports = __webpack_public_path__ + "static/media/concord.14b7a354.webp";